import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import axios from "../../api/axios";
import config from '../../config/config';

const Uploader = ({ id }) => {
    const [t, i18n] = useTranslation('global');
    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState({started: false, pc: 0 }); 
    const [msg, setMsg] = useState(null);

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({
        //accept: "application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint,text/plain, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document ",
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles);
          }
      });

      useEffect(()=> {
        setMsg('');
        setProgress(0);
      },[id]);

    function handleUpload() {
        if (!files.length > 0) {
            setMsg(t('noFileSelected')); 
            return;
        }

        const formData = new FormData();
        [...files].forEach((file) => {
            formData.append("files", file);
        });

        setMsg(t('uploading'));
        setProgress(prevState => {
            return {...prevState, started: true}
        })
        axios.post(config.endPoint + '/api/millai/SaveFile', formData, {
            onUploadProgress: (progressEvent) => { 
                setProgress(prevState => {
                    return {... prevState, pc: progressEvent.progress*100 }
                });
            },
            headers: {
                "json": JSON.stringify({ "docsEnvId": id }),  
            },
            withCredentials: true
        })
        .then(res => {
            setMsg(t('uploadSuccess'));
            console.log(res.data);
        })
        .catch(err => {
            setMsg(t('uploadError'));
            console.error(err);
        });
    }

    return (
        <div className="uploader">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {
                isDragActive ?
                  <p className="upload-drop">
                    <span className="material-symbols-outlined drag-drop">
                    download
                    </span>
                    {t('dropFilesHere')}
                  </p> :
                  <p className="upload-msg">
                    <span className="material-symbols-outlined drag-drop">
                    upload_file
                    </span>
                    {t('dragNDrop')}
                  </p>
              }
            </div>
            <ul>
                {acceptedFiles.map((file) => (
                    <li key={file.name}>{file.name} {file.type} {file.size} </li>
                ))}
            </ul>
            <button className="submit-button" onClick={() => handleUpload()}>{t('upload')}</button>  
            { progress.started && <progress className="upload-progress" max="100" value={progress.pc}></progress> }
            { msg && <span className="error-msg"> { msg }</span> }
        </div>
    );
}

export default Uploader;
